/**
 * Remembers the last page the user was on before opening Franklin, so the chat
 * can ask the API for help topics about that screen and tell it where a
 * question was asked from.
 *
 * Session-scoped on purpose: it describes where this tab is, not a preference.
 * Every read and write is guarded, since storage can be unavailable (private
 * windows, blocked site data) and the chat must work without it.
 */
const KEY = "franklin_last_route";

/** Routes that are not a "screen the user was on" for help purposes. */
const IGNORED_PREFIXES = ["/chatbot", "/login", "/waitlist", "/subscribe"];

export function rememberRoute(pathname: string): void {
    if (!pathname || IGNORED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return;
    try {
        window.sessionStorage.setItem(KEY, pathname);
    } catch {
        // Storage unavailable; the chat simply has no screen context.
    }
}

export function getLastRoute(): string | null {
    try {
        const value = window.sessionStorage.getItem(KEY);
        return value && value.startsWith("/") ? value : null;
    } catch {
        return null;
    }
}
